var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showDetail,
              expression: "!showDetail"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  attrs: {
                    "config-module": "10011",
                    reset: true,
                    "custom-search-items": _vm.customSearchItems,
                    "custom-sim-query-placeholder": _vm.$t(
                      "Pricing.PlsInputQuotationNo"
                    )
                  },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    advSearchItemCallBack: _vm.fetchData,
                    simSearchItemCallBack: _vm.fetchDataByKeyWord
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "look",
                            disabled: !_vm.selectedRow || _vm.filter.total <= 0,
                            type: "success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toLook()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.look")) + " ")]
                      ),
                      _vm.$checkPermission([
                        "button_FBAQuotation_editQuotation"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "edit",
                                disabled: !_vm.selectedRow,
                                type: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toEdit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("common.btn.edit")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["button_FBAQuotation_newQuotation"])
                        ? _c(
                            "el-dropdown",
                            {
                              staticStyle: { margin: "0 5px" },
                              attrs: {
                                no: "new",
                                "split-button": "",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.commandHandle()
                                },
                                command: function(p) {
                                  _vm.command = p
                                  _vm.commandHandle()
                                }
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.command) + " "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.$t("common.btn.new")
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle",
                                            "margin-left": "20px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.btn.new"))
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.$t(
                                          "Pricing.BatchImportQuotations"
                                        )
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "vertical-align": "middle"
                                        },
                                        attrs: {
                                          src: require("@/assets/fba-import.png")
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle",
                                            "margin-left": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Pricing.BatchImportQuotations"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: _vm.$t("Pricing.Template")
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          "vertical-align": "middle"
                                        },
                                        attrs: {
                                          src: require("@/assets/fba-download.png")
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "vertical-align": "middle",
                                            "margin-left": "2px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Pricing.Template"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-upload",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: false,
                                      expression: "false"
                                    }
                                  ],
                                  attrs: {
                                    action: "",
                                    accept: ".xls",
                                    "auto-upload": false,
                                    "show-file-list": false,
                                    "on-change": _vm.toChooseFile
                                  }
                                },
                                [
                                  _c("el-button", { ref: "uploadQuotationBtn" })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_FBAQuotation_deleteQuotation"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "delete",
                                disabled: !_vm.selectedRow,
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toDelete()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")) + " ")]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_FBAQuotation_exportQuotation"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "exportAllToExcel",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.exportAllToExcel()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("FbaChannel.exportQuotation"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_FBAQuotation_printQuotation"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "print", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.print()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("FbaChannel.printQuotation"))
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "1001101",
                      "grid-options": _vm.gridOptions,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      },
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "grid-params": _vm.gridParams,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "show-selected-color": false
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        this$1.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "1001101",
                      total: _vm.filter.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: function() {
                        if (_vm.filter.total > 0) {
                          _vm.fetchDataByPage
                        }
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.showDetail
        ? _c("quotation-detail", {
            ref: "quotationDetail",
            on: { backList: _vm.toBackPreView }
          })
        : _vm._e(),
      _c("cargo-template-select-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: {},
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }